import { ReactNode } from 'react';

import { DASHBOARD_CHART_HEIGHT } from '../constants/dashboardCharts';

import { Box } from '@cast/design-system';

type DashboardChartFrameProps = {
  children: ReactNode;
};

export const DashboardChartFrame = ({ children }: DashboardChartFrameProps) => (
  <Box height={DASHBOARD_CHART_HEIGHT} width="100%">
    {children}
  </Box>
);
